export default __webpack_public_path__ + "static/eberle-d0fc6f24d4ca6cf3777b6b985f2b98ab.jpg";